import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, ConfigProvider, Input, Layout, Pagination, Row, Statistic, Table, Tag, message } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import Search from 'antd/lib/input/Search'
import Cookies from 'js-cookie'
import OAMSider from '../oam-sider'
import { sendHttpPostRequest } from '../../../api/http-request'
import GlobalCss from '@/global.module.less'

const { Content } = Layout

export interface Props {}

export const OAMPaymentOrderList: React.FC<Props> = () => {
  const [orderList, setOrderList] = useState([] as any[])
  const [resultSum, setResultSum] = useState(0)
  const [paidCount, setPaidCount] = useState(0)

  const page = useRef(1)
  const pageSize = useRef(10)
  const queryContent = useRef('')

  const queryOrderList = () => {
    sendHttpPostRequest(
      'payment/api/oam_query_order_list',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        page: page.current,
        pagesize: pageSize.current,
        query: queryContent.current,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          window.location.href = '/oam_login?next=oam_purchase_list'
        } else if (response.is_ok == true) {
          const list = response.query_list || []
          setOrderList(list)
          setResultSum(response.total_sum || 0)
          setPaidCount(list.filter((item) => item.status == 2).length)
        } else {
          message.error(response.message || '查询购买列表失败')
        }
      }
    )
  }

  useEffect(() => {
    queryOrderList()
  }, [])

  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    queryOrderList()
  }

  const onPageChange = (newPage: number, newPageSize?: number) => {
    page.current = newPage || 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryOrderList()
  }

  const columns: any[] = [
    {
      title: '订单号',
      dataIndex: 'order_no',
      key: 'order_no',
      width: 220,
      ellipsis: true,
    },
    {
      title: '项目',
      dataIndex: 'course_name',
      key: 'course_name',
      width: 180,
      ellipsis: true,
    },
    {
      title: '用户',
      dataIndex: 'user_name',
      key: 'user_name',
      width: 120,
      ellipsis: true,
      render: (text: string, record: any) => record?.user_real_name || text || '-',
    },
    {
      title: '支付金额',
      dataIndex: 'amount_yuan',
      key: 'amount_yuan',
      width: 100,
      align: 'right',
      render: (text: string) => `¥${text || '0.00'}`,
    },
    {
      title: '状态',
      dataIndex: 'status_text',
      key: 'status_text',
      width: 100,
      align: 'center',
      render: (text: string, record: any) => {
        const color = record?.status == 2 ? 'green' : record?.status == 1 ? 'orange' : 'default'
        return <Tag color={color}>{text}</Tag>
      },
    },
    {
      title: '支付时间',
      dataIndex: 'paid_at',
      key: 'paid_at',
      width: 180,
      ellipsis: true,
      render: (text: string) => text || '-',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 180,
      ellipsis: true,
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={'payment_order'} openKeys={['sub-project']}></OAMSider>
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30 }}>
            <Row align="middle" gutter={16}>
              <Col flex="100px">
                <Statistic title="订单总数" value={resultSum} />
              </Col>
              <Col flex="100px">
                <Statistic title="当前页已支付" value={paidCount} />
              </Col>
              <Col flex="250px">
                <Search
                  placeholder="搜索订单号/项目/用户"
                  style={{ width: 350 }}
                  enterButton={true}
                  onSearch={onSearchBtn}
                />
              </Col>
            </Row>

            <div style={{ height: 500 }} className={GlobalCss.tableWrapper}>
              <ConfigProvider locale={zhCN}>
                <Table
                  scroll={{ x: 1000 }}
                  dataSource={orderList}
                  columns={columns}
                  rowKey={(record) => record.id}
                  pagination={false}
                />
              </ConfigProvider>
            </div>

            <ConfigProvider locale={zhCN}>
              <div
                style={{
                  marginBottom: 30,
                  paddingTop: 30,
                  textAlign: 'center',
                }}
                className={'css.pagination'}
              >
                <Pagination
                  defaultCurrent={1}
                  total={resultSum}
                  current={page.current}
                  defaultPageSize={10}
                  hideOnSinglePage={true}
                  onChange={onPageChange}
                  showQuickJumper={true}
                  showTotal={(total) => `共 ${total} 订单`}
                  pageSizeOptions={['10', '20', '50', '100']}
                />
              </div>
            </ConfigProvider>
          </div>
        </Content>
      </Layout>
    </Layout>
  )
}

export default OAMPaymentOrderList
